import { DropdownMultiSelect,
  CalendarComponent,
  InputBox,
  DropdownSingleSelect,
  TextArea as InputTextarea,
  classNames, ToggleButton,
  SelectButton,
  Rating,
  RadioTypeButton } from 'az-platform-ui';

const getFormErrorMessage = (name, formik) => (isFormFieldValid(name, formik) && <small className="p-error">{formik.errors[name]}</small>);

export const isFormFieldValid = (name, formik) => {
// for FieldArray validation 
// if formik have array type of values eg { list: [{name:''}]}
// let names = name && name.split('.');

// if (names && names.length >= 2) {
//   let _name = names[names.length - 1];
//   let index = +(names[1]);
//   let parentName = names[0];
//   let { touched, errors } = formik;
//   let touch, error;
//   if (parentName) {
//     errors = errors[parentName];
//     touched = touched[parentName];
//   }
//   if (errors && errors.length && index >= 0 && _name) {
//     error = errors[index] && errors[index][_name];
//   }
//   if (touched && touched.length && index >= 0 && _name) {
//     touch = touched[index] && touched[index][_name];
//   }
//   return !!(touch && error);
// } else {
if ( name && formik && name.indexOf('.')>=0) {
return !!(formik.errors[name]);
}
else {
return !!(formik.touched[name] && formik.errors[name]);
}
// }
};

export const Label = (props) => <label style={props.style} htmlFor={props.name} className={classNames({ 'p-error': isFormFieldValid(props.name, props.formik) }, props.className)}> {props.title}</label>

export const addClassName = (name, formik) => {
return classNames({ 'p-invalid': isFormFieldValid(name, formik) })
}

export const RatingStar=(props) => {
let { formik, name, value, id  } = props;
return <Rating
className={classNames(addClassName(name, formik), 'text-xs')}
onChange={formik.handleChange}
name={name}
id ={id}
value={(value !== undefined ? value : formik.values[name])} 
pt={{
  onIcon: { className: 'text-orange-400 -ml-2 pl-1' },
  offIcon: { className: 'text-600	-ml-2 pl-1' },
  item: { className: 'p-1 ' }

}}
cancel={props.cancel || false}
/>
}


export const RadioGroup = (props) => {
let { title, formik, name, value, id, className } = props;
return (
<>
<div className="p-float-label flex flex-row">
  <RadioTypeButton
    {...props}
    className={classNames(addClassName(name, formik), 'text-xs')}
    checked={formik.values[name] === value}
    inputId={id}
    onChange={formik.handleChange}
    value={value} />

  <Label title={title} name={name} formik={formik} className={classNames(className , 'ml-3')} htmlFor={id} />
</div>
{getFormErrorMessage(name, formik)}
</>)
}


export const SelectOption = (props) => {
let { title, formik, name, label,value, className } = props;
const isLabel = label === false ? false : true;
let dropdownProps = { ...props };
delete dropdownProps.label;

return (
<>
<div className={classNames("p-float-label", { 'mt-5': isLabel })} >
  <SelectButton
    {...dropdownProps}
    className={classNames(addClassName(name, formik), 'text-xs', className)}
    onChange={formik.handleChange}
    value={(value !== undefined ? value : formik.values[name])} />

  {isLabel && <Label title={title} name={name} formik={formik} />}
</div>
{getFormErrorMessage(name, formik)}
</>)
}


export const SingleDropdown = (props) => {
let { formik, name, showFloatingLabel,value, className , onChange} = props;
let dropdownProps = { ...props };
return (
<>
<div className={classNames('mt-1', {'mt-3': showFloatingLabel})}>
  <DropdownSingleSelect
    {...dropdownProps}
    className={classNames(addClassName(name, formik), 'text-xs', className)}
    onChange={(e) => {if ( onChange) {onChange(e);} formik.handleChange(e)}}
    value={(value !== undefined ? value : formik.values[name])} />

  {/* {isLabel && <Label title={title} name={name} formik={formik} />} */}
</div>
{getFormErrorMessage(name, formik)}
</>)
}

export const InputField = (props) => {
let { name, title, icon, formik, label, value, onBlur, onFocus } = props;
const floatLabel = label === false ? false : true;
let inputProps = { ...props };
delete inputProps.label;
return (
<div className={classNames({ 'mt-5': floatLabel })}>
<span className={`p-float-label ${icon ? 'p-input-icon-left' : ''}`}>
  {icon && <i className={`pi ${icon}`} />}
  <InputBox
    {...inputProps}
    value={(value !== undefined ? value : formik.values[name])} 
    onChange={formik.handleChange}
    onBlur={(e) => {
      if(onBlur) {
        onBlur(e)
      }
      formik.handleBlur(e)
    }}
    onFocus= {onFocus ? onFocus : () => {}}
    className={addClassName(name, formik)}
  />
  {floatLabel && <Label title={title} name={name} formik={formik} />}
</span>
{getFormErrorMessage(name, formik)}
</div>)
}

export const TextArea = (props) => {
let { name, title, formik, label } = props;
const floatLabel = label === false ? false : true;
let inputProps = { ...props };
delete inputProps.label;

return (
<>
<span className="p-float-label">
  <InputTextarea
    {...inputProps}
    value={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    className={addClassName(name, formik)} />
  {floatLabel && <Label title={title} name={name} formik={formik} />}
</span>
{getFormErrorMessage(name, formik)}
</>)
}

export const SelectButtonGroup = (props) => {
let { name, formik, className } = props;
let inputProps = { ...props };
delete inputProps.label;

return (
<>
<span className={classNames("p-float-label", className)} >
  <SelectButton
    {...inputProps}
    value={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    className={addClassName(name, formik)} />
</span>
{getFormErrorMessage(name, formik)}
</>)

}

export const SwitchButton = (props) => {
let { name, formik, className } = props;
let inputProps = { ...props };
delete inputProps.label;

return (
<>
<span className={classNames("p-float-label", className)} >
  <ToggleButton
    {...inputProps}
    value={formik.values[name]}
    checked={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    className={addClassName(name, formik)} />
</span>
{getFormErrorMessage(name, formik)}
</>)

}

export const MultiDropdown = (props) => {
let { name, formik, className } = props;
let inputProps = { ...props };
delete inputProps.label;
return (
<>
<span className={classNames("p-float-label", className)} >
  <DropdownMultiSelect
    {...inputProps}
    value={formik.values[name]}
    checked={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    className={addClassName(name, formik)} />
</span>
{getFormErrorMessage(name, formik)}
</>)


}

export const DateInput = (props) => {
let { name, formik, className } = props;
let inputProps = { ...props };
delete inputProps.label;
return (
<>
<span className={classNames("p-float-label", className)} >
  <CalendarComponent
    {...inputProps}
    value={formik.values[name]}
    checked={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    className={addClassName(name, formik)} />
</span>
{getFormErrorMessage(name, formik)}
</>)


}